import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { object, string } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const ProgressBar = ({ label, count, total, color }) => {
  const percent = total > 0 ? Math.round((count / total) * 100) : 0;
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          mb: 1,
        }}
      >
        <Typography
          variant="overline"
          sx={{
            color: 'text.secondary',
            lineHeight: 1,
            fontWeight: 700,
          }}
        >
          {label}
        </Typography>
        <Box
          sx={{
            textAlign: 'right',
            display: 'flex',
            alignItems: 'flex-end',
            gap: 1,
          }}
        >
          <Typography
            variant="subtitle1"
            component="span"
            sx={{
              fontWeight: 700,
              lineHeight: '16px',
            }}
          >
            {count}/{total}
          </Typography>
          <Typography
            variant="body2"
            component="span"
            sx={{
              color: 'text.secondary',
              lineHeight: '16px',
            }}
          >
            ({percent}%)
          </Typography>
        </Box>
      </Box>
      <LinearProgress
        variant="determinate"
        value={percent}
        sx={{
          height: 8,
          borderRadius: 999,
          backgroundColor: 'action.hover',
          '& .MuiLinearProgress-bar': { backgroundColor: color, borderRadius: 999 },
        }}
      />
    </Box>
  );
};

const ContentProgressBars = ({ contentMode, counters }) => {
  const theme = useTheme();
  const { read = 0, totalCount = 0, videoWatches = 0, articleReads = 0 } = counters;

  const primaryColor = theme.palette.primary.main;
  const engagedColor = theme.palette.success?.main || theme.palette.onOffChartSeries?.[0];

  return (
    <Stack
      sx={{
        gap: 3,
      }}
    >
      <ProgressBar
        label={I18n.t('EmployeeListDrawer.seenBy')}
        count={read}
        total={totalCount}
        color={primaryColor}
      />
      {contentMode === 'video' && (
        <ProgressBar
          label={I18n.t('EmployeeListDrawer.watchedBy')}
          count={videoWatches}
          total={totalCount}
          color={engagedColor}
        />
      )}
      {contentMode === 'article' && (
        <ProgressBar
          label={I18n.t('EmployeeListDrawer.readBy')}
          count={articleReads}
          total={totalCount}
          color={engagedColor}
        />
      )}
    </Stack>
  );
};

ContentProgressBars.propTypes = {
  contentMode: string.isRequired,
  counters: object.isRequired,
};

export default ContentProgressBars;
